module.exports = __webpack_public_path__ + "static/media/image-8.aa68ecc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-64/image-8.jpg
// module id = 268
// module chunks = 0